'use strict';

// `pdfmake` has a documentation string in it that causes SystemJS to try to load a "stream" package. That package does
// not exist. We work around this here by telling SystemJS that the package is already loaded.
System.register('/stream', [], function() {
    return {
        setters: [],
        execute: function() {},
    };
});

/**
 * Tells SystemJS where dependencies live and how to load them efficiently.
 *
 * The SystemJS Config API is documented at
 * https://github.com/systemjs/systemjs/blob/master/docs/config-api.md
 *
 * Multiple calls to `System.config()` result in a merged config.
 */
System.config({
    // Allows importing files without specifying their extensions, e.g. `System.import('/modules/utils/utils')`.
    packages: {
        '/': {
            defaultExtension: 'js',
            format: 'cjs',
        },
        '/modules': {
            defaultExtension: 'js',
            format: 'cjs',
        },
        '/pages': {
            defaultExtension: 'js',
            format: 'cjs',
        },
        '/services': {
            defaultExtension: 'js',
            format: 'cjs',
        },
        '/vendor': {
            defaultExtension: 'min.js',
            format: 'cjs',
        },
    },
    // Accommodates the way TypeScript imports third-party JS libraries. This allows us to do something like
    // `import * as MainLoop from 'mainloop.js';` and have it resolve to the correct file location at runtime.
    map: {
        'amplitude-js':'/vendor/a/a.min.js',
        bigscreen:     '/vendor/bigscreen/bigscreen.min.js',
        c3:            '/vendor/c3/c3.min.js',
        d3:            '/vendor/d3/d3.min.js',
        'd3-latest':   '/vendor/d3-latest/d3.min.js',
        'hashids':     '/vendor/hashids/dist/hashids.min.js',
        'mainloop.js': '/vendor/mainloop.js/build/mainloop.min.js',
        stream:        '/stream',
        'timeago.js':  '/vendor/timeago.js/timeago.min.js',
        tslib:         '/vendor/tslib/tslib.min.js',
        'monaco-editor': '/vendor/monaco-editor/vs/editor/editor.main.min.js',
        qs:            '/vendor/qs/qs.min.js',
    },
    meta: {
        '/stream': {
            format: 'register'
        },
    },
    // Compensates for SystemJS Builder's tendency to assign relative paths to modules.
    paths: { '*': '/*' },
});

// The config below is auto-generated by `grunt bundle`
System.config({
// Instructs SystemJS which bundle file to load when a dependency is requested.
bundles: {
    "/bundles/account-page-bundle.min.js": [
        "/modules/password-strength/password-strength.js",
        "/pages/account/account-page.js",
        "/pages/account/fields/account-alert-digest-day-of-week-field.js",
        "/pages/account/fields/account-alert-digest-delivery-time-field.js",
        "/pages/account/fields/account-alert-digest-frequency-field.js"
    ],
    "/bundles/account-page-users-page-bundle.min.js": [
        "/modules/utils/field-status.js",
        "/modules/utils/field-with-status.js",
        "/pages/account/fields/account-job-title-field.js",
        "/pages/account/fields/account-job-title-list-field.js",
        "/pages/account/fields/account-location-field.js"
    ],
    "/bundles/activity-page-bundle.min.js": [
        "/modules/processflow/activity.js",
        "/modules/processflow/activitymodel.js",
        "/modules/processflow/activityview.js",
        "/pages/reports/activity-page.js"
    ],
    "/bundles/activity-page-report-page-springboard-page-bundle.min.js": [
        "/modules/components/deprecation-warning-banner/deprecation-warning-banner.js"
    ],
    "/bundles/alert-rule-page-bundle.min.js": [
        "/modules/alert-rules/alert-rule-chart-controller.js",
        "/modules/alert-rules/alert-rule-chart-placeholder-controller.js",
        "/modules/alert-rules/alert-rule-chart-placeholder-view.js",
        "/modules/alert-rules/alert-rule-chart-view.js",
        "/modules/alert-rules/alert-rule-controller.js",
        "/modules/alert-rules/alert-rule-form-controller.js",
        "/modules/alert-rules/alert-rule-form-view.js",
        "/modules/alert-rules/alert-rule-model.js",
        "/modules/alert-rules/alert-rule-view.js",
        "/modules/alert-rules/es-queries.js",
        "/modules/alert-rules/facades/alert-rule-defect-rate-metric-facade.js",
        "/modules/alert-rules/facades/alert-rule-dfxid-matcher-facade.js",
        "/modules/alert-rules/facades/alert-rule-entity-matching-rules-facade-builder.js",
        "/modules/alert-rules/facades/alert-rule-facade-builder.js",
        "/modules/alert-rules/facades/alert-rule-facade.js",
        "/modules/alert-rules/facades/alert-rule-intercept-rate-metric-facade.js",
        "/modules/alert-rules/facades/alert-rule-kpi-digest-metric-facade.js",
        "/modules/alert-rules/facades/alert-rule-metric-entity-set-aggregation-facade.js",
        "/modules/alert-rules/facades/alert-rule-metric-entity-set-facade-builder.js",
        "/modules/alert-rules/facades/alert-rule-metric-entity-set-with-matching-rules-facade.js",
        "/modules/alert-rules/facades/alert-rule-numeric-external-measurement-metric-facade.js",
        "/modules/alert-rules/facades/alert-rule-numeric-external-measurement-metric-matcher-facade.js",
        "/modules/alert-rules/facades/alert-rule-spc-trigger-facade.js",
        "/modules/alert-rules/facades/alert-rule-station-intercept-matcher-facade.js",
        "/modules/alert-rules/facades/alert-rule-trigger-facade.js",
        "/modules/alert-rules/facades/alert-rule-triggers-facade-builder.js",
        "/modules/alert-rules/facades/alert-rule-unconfirmed-rad-results-metric-facade.js",
        "/modules/alert-rules/facades/alert-rule-upper-bound-trigger-facade.js",
        "/modules/alert-rules/fields/alert-rule-bucket-size-field.js",
        "/modules/alert-rules/fields/alert-rule-directly-targeted-users-field.js",
        "/modules/alert-rules/fields/alert-rule-email-recipients-field.js",
        "/modules/alert-rules/fields/alert-rule-email-subject-field.js",
        "/modules/alert-rules/fields/alert-rule-entities-field.js",
        "/modules/alert-rules/fields/alert-rule-entities-type-field.js",
        "/modules/alert-rules/fields/alert-rule-id-field.js",
        "/modules/alert-rules/fields/alert-rule-metric-field.js",
        "/modules/alert-rules/fields/alert-rule-trigger-field.js",
        "/modules/alert-rules/fields/alert-rule-upper-bound-trigger-field.js",
        "/pages/alert-rules/alert-rule-page.js"
    ],
    "/bundles/alert-rule-page-correlation-page-metrics-page-relationships-page-bundle.min.js": [
        "/modules/alert-rules/facades/alert-rule-entity-matching-rules-facade.js"
    ],
    "/bundles/alert-rule-page-dashboard-page-recurring-report-page-users-page-bundle.min.js": [
        "/modules/users/users-helpers.js"
    ],
    "/bundles/alert-rules-page-bundle.min.js": [
        "/modules/alert-rules/alert-rules-controller.js",
        "/modules/alert-rules/alert-rules-list-controller.js",
        "/modules/alert-rules/alert-rules-list-view.js",
        "/modules/alert-rules/alert-rules-view.js",
        "/pages/alert-rules/alert-rules-page.js"
    ],
    "/bundles/comment-threads-page-bundle.min.js": [
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIListCommentThreadsResponse.js",
        "/modules/comment-threads/comment-threads-controller.js",
        "/modules/comment-threads/comment-threads-view.js",
        "/pages/comment-threads/comment-threads-page.js"
    ],
    "/bundles/common-bundle.min.js": [
        "/app-config.js",
        "/bootstrap.js",
        "/modules/alert-rules/alert-rule-helpers.js",
        "/modules/alert-rules/facades/alert-rule-metric-entity-set-facade.js",
        "/modules/api/api-project-model.js",
        "/modules/api/api-proto-search-types.js",
        "/modules/api/api-proto-types.js",
        "/modules/api/api-user-model.js",
        "/modules/api/api.js",
        "/modules/api/bindings/dfx/schemas/proto/ProjectOpsDashboardSettings.js",
        "/modules/api/bindings/dfx/schemas/proto/anml/CorrelateDataInternalValueType.js",
        "/modules/api/bindings/dfx/schemas/proto/anml/CorrelationTier.js",
        "/modules/api/bindings/dfx/schemas/proto/anml/ExternalMeasurementType.js",
        "/modules/api/bindings/dfx/schemas/proto/anml/SubscriptionSensitivityTradeoff.js",
        "/modules/api/bindings/dfx/schemas/proto/api/alerting/APIAggregationType.js",
        "/modules/api/bindings/dfx/schemas/proto/api/alerting/APIDeliveryMethod.js",
        "/modules/api/bindings/dfx/schemas/proto/api/alerting/APIXBarControlLimitTrigger.js",
        "/modules/api/bindings/dfx/schemas/proto/api/correlation/APICorrelationJobState.js",
        "/modules/api/bindings/dfx/schemas/proto/api/correlation/APICorrelationMetricClassification.js",
        "/modules/api/bindings/dfx/schemas/proto/api/fromfixture/ABSResult.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIAddDiscoverLabelsRequest.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIBulkDeleteImageFeatureMeasurementsRequest.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIChangelog.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIExternalMeasurementClassificationType.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIGuidedAnomalyDetectionErrorCode.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIGuidedAnomalyDetectionErrorMetadataKey.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIImageFeatureMeasurementType.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIListDiscoverMonitorsRequestCropCondition.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIListDiscoverMonitorsRequestCropInterceptCondition.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIListDiscoverMonitorsRequestMonitorCropInterceptCondition.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIListDiscoverMonitorsRequestRegionCondition.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIListDiscoverMonitorsRequestUnseenCropCondition.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIListMetricsDataType.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIListMetricsRequest.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIListRADResultsErrorCode.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIMeasurementFlag.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIRADResultStatus.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIRetestMethod.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APISaveImageFeatureErrorCode.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APISubscriptionImageHidingBehavior.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APISubscriptionRtdStatus.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APISubscriptionStatus.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APISubscriptionVisibility.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIUserAuthenticationMethod.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/RequestType.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/SavedStringType.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/api_list_rad_label_enum/APIListRADLabelType.js",
        "/modules/api/bindings/dfx/schemas/proto/api/recurringreport/APIRecurringReportFrequency.js",
        "/modules/api/bindings/dfx/schemas/proto/api/recurringreport/APIRecurringReportType.js",
        "/modules/api/bindings/dfx/schemas/proto/api/settings/user/APIUserAlertDigestSetting.js",
        "/modules/api/bindings/dfx/schemas/proto/db/UserRole.js",
        "/modules/api/bindings/dfx/schemas/proto/labels/RADLabelType.js",
        "/modules/api/bindings/dfx/schemas/proto/labels/SubscriptionLabel.js",
        "/modules/api/bindings/dfx/schemas/proto/search/SearchMeasurement.js",
        "/modules/api/bindings/dfx/schemas/proto/search/SearchMeasurementImageFeatureType.js",
        "/modules/api/bindings/dfx/schemas/proto/search/SearchUnitMeasurement.js",
        "/modules/api/bindings/dfx/schemas/proto/search/SearchUnitMeasurementExecutor.js",
        "/modules/api/bindings/dfx/schemas/proto/search/SearchUnitMeasurementFlag.js",
        "/modules/api/bindings/dfx/schemas/proto/search/SearchUnitRADLabel.js",
        "/modules/api/bindings/dfx/schemas/proto/search/SearchUnitSubscriptionLabel.js",
        "/modules/api/bindings/dfx/schemas/proto/search/SearchUnitSubscriptionLabelSource.js",
        "/modules/api/bindings/dfx/schemas/proto/subscription/SubscriptionCandidateStatus.js",
        "/modules/api/bindings/dfx/schemas/proto/subscription/SubscriptionStatus.js",
        "/modules/api/gendata.js",
        "/modules/api/proto.js",
        "/modules/api/restricted-projects.js",
        "/modules/back-to-top-button/back-to-top-button-controller.js",
        "/modules/cache/cache-data.js",
        "/modules/cache/cache.js",
        "/modules/cards/imagecard.js",
        "/modules/chart/chart-controller.js",
        "/modules/chart/chart-helpers.js",
        "/modules/chart/chart-view.js",
        "/modules/chart/historical-data-indicator.js",
        "/modules/charts/rate-over-time-chart-layout.js",
        "/modules/charts/rate-over-time-chart.js",
        "/modules/chrome/a.js",
        "/modules/chrome/custom-svgs.js",
        "/modules/chrome/project-switcher.js",
        "/modules/chrome/vendor.js",
        "/modules/chrome/witty-messages.js",
        "/modules/comments/comment-helpers.js",
        "/modules/comments/comment-model.js",
        "/modules/comments/comment-view.js",
        "/modules/comments/comment.js",
        "/modules/components/action-icon-button/action-icon-button.js",
        "/modules/components/crop-card/crop-card-zoom-control.js",
        "/modules/components/crop-card/crop-details.js",
        "/modules/components/crop-card/crop-image.js",
        "/modules/components/crop-card/crop-labeling-button.js",
        "/modules/components/crop-card/crop-labeling-buttons.js",
        "/modules/components/crop-card/crop-labeling-history.js",
        "/modules/components/crop-card/crop-outline.js",
        "/modules/components/crop-card/current-label-source.js",
        "/modules/components/crop-card/monitor-crop-card.js",
        "/modules/components/crop-card/other-inspections-shadow.js",
        "/modules/components/crop-card/prediction-source.js",
        "/modules/components/crop-card/siemens-example-crop-card.js",
        "/modules/components/crop-card/types.js",
        "/modules/components/details/details.js",
        "/modules/components/editable-field/editable-field.js",
        "/modules/components/icon-button-group/icon-button-group.js",
        "/modules/components/image-configs/image-config-badge.js",
        "/modules/components/image-configs/image-configs-map.js",
        "/modules/components/loading-hellip/loading-hellip.js",
        "/modules/components/opt-in-buttons/grid-opt-in-button.js",
        "/modules/components/opt-in-buttons/monitors-opt-in-button.js",
        "/modules/components/opt-in-buttons/units-opt-in-button.js",
        "/modules/components/pagination/pagination-buttons.js",
        "/modules/components/pagination/pagination.js",
        "/modules/components/progress-bar/progress-bar.js",
        "/modules/components/toggle-switch-widget/toggle-switch-widget.js",
        "/modules/components/toggle-switch/toggle-switch.js",
        "/modules/components/warning-banner/warning-banner.js",
        "/modules/correlations/correlations-controller.js",
        "/modules/correlations/correlations-model.js",
        "/modules/correlations/correlations-view.js",
        "/modules/correlations/features/bookmarked-correlations/bookmarked-correlations.js",
        "/modules/correlations/features/correlation-card/correlation-card.js",
        "/modules/correlations/features/correlation-classification-badge/correlation-classification-badge.js",
        "/modules/correlations/features/dvc-relationship-card/dvc-crop-card.js",
        "/modules/correlations/features/recent-correlations/recent-correlations.js",
        "/modules/correlations/queries/correlation-service.js",
        "/modules/correlations/shared/api-correlation-wrappers.js",
        "/modules/correlations/shared/correlation-relationship.js",
        "/modules/correlations/shared/correlations-helpers.js",
        "/modules/correlations/shared/correlations-url-builder.js",
        "/modules/correlations/shared/types.js",
        "/modules/discover/discover-controller.js",
        "/modules/discover/discover-model.js",
        "/modules/discover/discover-view.js",
        "/modules/discover/features/discover-advanced-filters-preset-dropdown.js",
        "/modules/discover/features/discover-date-picker.js",
        "/modules/discover/features/discover-image-monitor-button.js",
        "/modules/discover/features/discover-intercept-filter.js",
        "/modules/discover/features/discover-label-progress-bar.js",
        "/modules/discover/features/discover-new-anomalies-section.js",
        "/modules/discover/features/discover-region-advanced-review-filters.js",
        "/modules/discover/features/discover-region-comment-entities.js",
        "/modules/discover/features/discover-region-list.js",
        "/modules/discover/features/discover-region-results.js",
        "/modules/discover/features/discover-region-review-filters-option.js",
        "/modules/discover/features/discover-region-review-filters.js",
        "/modules/discover/features/discover-region/crops-group-action-button.js",
        "/modules/discover/features/discover-region/crops-group-photo-store.js",
        "/modules/discover/features/discover-region/discover-region-crops-group-header.js",
        "/modules/discover/features/discover-region/discover-region-crops-group.js",
        "/modules/discover/features/discover-region/discover-region-crops.js",
        "/modules/discover/features/discover-region/grouped-crops-state.js",
        "/modules/discover/features/heatmap/discover-heatmap-entities.js",
        "/modules/discover/features/unit-crop-card-icon.js",
        "/modules/discover/features/unit-crop-card.js",
        "/modules/discover/features/unit-crop-labeling.js",
        "/modules/discover/queries/discover-monitor-service.js",
        "/modules/discover/queries/discover-photos-images-service.js",
        "/modules/discover/queries/discover-region-model.js",
        "/modules/discover/queries/discover-region-repository.js",
        "/modules/discover/queries/reference-crop-service.js",
        "/modules/discover/queries/units-page-url-service.js",
        "/modules/discover/shared/crop-label-history.js",
        "/modules/discover/shared/discover-analytics.js",
        "/modules/discover/shared/discover-helpers.js",
        "/modules/discover/shared/discover-url-utils.js",
        "/modules/discover/shared/discover-utils.js",
        "/modules/discover/shared/events.js",
        "/modules/discover/shared/types.js",
        "/modules/discover/shared/unit-crop-card-photo.js",
        "/modules/discover/shared/unit-filters.js",
        "/modules/edi/edi-helpers.js",
        "/modules/edi/edi-limits-helpers.js",
        "/modules/elasticsearch/factories/factories-helpers.js",
        "/modules/elasticsearch/factories/internal-inspections-queries.js",
        "/modules/elasticsearch/factories/internal-measurements-queries.js",
        "/modules/elasticsearch/factories/monitor-label-queries.js",
        "/modules/elasticsearch/query-fragments/serial-numbers.js",
        "/modules/events/events.js",
        "/modules/featureflags/featureflags.js",
        "/modules/featureflags/internal-only-overrides.js",
        "/modules/featureflags/retired-flags.js",
        "/modules/filter/filter-es6.js",
        "/modules/gallery/gallery-decks.js",
        "/modules/gallery/gallery-internal-decks.js",
        "/modules/gallery/gallery.js",
        "/modules/gallery/unit-measurement-helpers.js",
        "/modules/heatmaps/discover/discover-heatmap-view.js",
        "/modules/heatmaps/discover/discover-heatmap.js",
        "/modules/heatmaps/es-queries.js",
        "/modules/heatmaps/heatmap-helpers.js",
        "/modules/heatmaps/heatmap-view.js",
        "/modules/heatmaps/heatmap.js",
        "/modules/hero/hero.js",
        "/modules/hero/layer.js",
        "/modules/hero/scale.js",
        "/modules/hidden-photos/hidden-photos-filters-controller.js",
        "/modules/hidden-photos/hidden-photos-filters-view.js",
        "/modules/image-config-filters/es-queries.js",
        "/modules/image-config-filters/image-config-filter-row.js",
        "/modules/image-config-filters/image-config-filters.js",
        "/modules/image-config-filters/image-config-helpers.js",
        "/modules/image-config-filters/image-config-tooltip.js",
        "/modules/imageentity/imageentity.js",
        "/modules/itar/itar-helpers.js",
        "/modules/logout/logout.js",
        "/modules/measurements/es-queries.js",
        "/modules/measurements/imagemetrics-helpers.js",
        "/modules/measurements/measurement-helpers.js",
        "/modules/mentions/mention.js",
        "/modules/metric-distributions/metric-partition.js",
        "/modules/metric-distributions/metrics-page-adapters.js",
        "/modules/metric-distributions/numeric-distribution-query-builder.js",
        "/modules/metric-distributions/numeric-distribution-repository.js",
        "/modules/metric-distributions/numeric-limit.js",
        "/modules/metrics/charts/control-chart-helpers.js",
        "/modules/metrics/charts/distribution-data-wrapper.js",
        "/modules/metrics/charts/metric-distribution-chart-helper.js",
        "/modules/metrics/charts/metric-distribution-chart.js",
        "/modules/metrics/es-queries.js",
        "/modules/metrics/filters/metrics-filters-defaults.js",
        "/modules/metrics/metrics-model.js",
        "/modules/metrics/physical-metric-helpers.js",
        "/modules/metrics/physical-metric-limits-helpers.js",
        "/modules/metrics/shared-models/metric-data-types.js",
        "/modules/modals/adjust-region-modal.js",
        "/modules/modals/alert.js",
        "/modules/modals/anomalyloadingmodal.js",
        "/modules/modals/api-keys-modal-view.js",
        "/modules/modals/api-keys-modal.js",
        "/modules/modals/confirmmodal.js",
        "/modules/modals/cui-confirm-modal.js",
        "/modules/modals/export-monitor-to-siemens-modal.js",
        "/modules/modals/feedbackmodal.js",
        "/modules/modals/modal.js",
        "/modules/modals/poc-add-project-modal.js",
        "/modules/modals/set-metric-limits-modal.js",
        "/modules/modals/subscribemodal.js",
        "/modules/pdf-exports/pdf-default-styles.js",
        "/modules/pdf-exports/pdf-elements.js",
        "/modules/pdf-exports/pdf-export.js",
        "/modules/pdf-exports/pdf-helpers.js",
        "/modules/pdf-exports/pdf-standard-doc-elements.js",
        "/modules/pdf-exports/pdf.js",
        "/modules/permissions/feature-access.js",
        "/modules/permissions/permission-scope.js",
        "/modules/permissions/permissions.js",
        "/modules/processflow/processflowmodel.js",
        "/modules/project-home-2/project-home-helpers.js",
        "/modules/project-settings/project-settings-helpers.js",
        "/modules/rad/es-queries.js",
        "/modules/rad/rad-helpers.js",
        "/modules/rad/rad-model.js",
        "/modules/rad/rad-results-controller.js",
        "/modules/rad/rad-results-view.js",
        "/modules/rate-over-time-chart/rate-over-time-chart-controller.js",
        "/modules/rate-over-time-chart/rate-over-time-chart-view.js",
        "/modules/recurring-reports/recurring-report-helpers.js",
        "/modules/relationships/boolean-limits-form.js",
        "/modules/relationships/es-queries.js",
        "/modules/relationships/numeric-limits-form.js",
        "/modules/relationships/physical-limits-form.js",
        "/modules/relationships/relationships-charts-helpers.js",
        "/modules/relationships/relationships-helpers.js",
        "/modules/relationships/relationships-model.js",
        "/modules/relationships/string-limits-form.js",
        "/modules/router/appcontext.js",
        "/modules/router/component.js",
        "/modules/router/context.js",
        "/modules/router/mocks.js",
        "/modules/router/page.js",
        "/modules/router/router.js",
        "/modules/scrollbars/scrollbars.js",
        "/modules/search/querybuilder.js",
        "/modules/search/search-unit-filter-history-controller.js",
        "/modules/search/search-unit-filter-history-model.js",
        "/modules/search/search-unit-filter-history.js",
        "/modules/search/search.js",
        "/modules/search/searchunitmeasurementmodel.js",
        "/modules/search/searchunitmodel.js",
        "/modules/searchresults/anomalystate.js",
        "/modules/searchresults/minimap.js",
        "/modules/searchresults/searchresults.js",
        "/modules/searchresults/units-helpers.js",
        "/modules/selectors/checkbox-selector.js",
        "/modules/selectors/photo-backdate-selector.js",
        "/modules/subscriptions/es-queries.js",
        "/modules/subscriptions/interfaces.js",
        "/modules/subscriptions/monitor-adjust-region.js",
        "/modules/subscriptions/monitor-card/crop-buttons.js",
        "/modules/subscriptions/monitor-card/monitor-card.js",
        "/modules/subscriptions/monitor-card/monitor-crops-state.js",
        "/modules/subscriptions/monitor-card/monitor-indicator-badge.js",
        "/modules/subscriptions/monitor-card/monitor-info.js",
        "/modules/subscriptions/monitor-comment-entities.js",
        "/modules/subscriptions/monitor-crop-labeling-history.js",
        "/modules/subscriptions/monitor-group-state-manager.js",
        "/modules/subscriptions/monitor-grouping.js",
        "/modules/subscriptions/monitor-heatmap-entities.js",
        "/modules/subscriptions/monitor-heatmap-helpers.js",
        "/modules/subscriptions/monitor-pdf-export-helpers.js",
        "/modules/subscriptions/monitor-report-pdf-export.js",
        "/modules/subscriptions/monitor-retraining/monitor-retraining-badge.js",
        "/modules/subscriptions/monitor-retraining/monitor-retraining-state.js",
        "/modules/subscriptions/monitors-pdf-export.js",
        "/modules/subscriptions/owners.js",
        "/modules/subscriptions/services/monitor-crop-photos-service.js",
        "/modules/subscriptions/services/monitor-retraining-service.js",
        "/modules/subscriptions/services/subscription-unit-repository.js",
        "/modules/subscriptions/subscriptions-helpers.js",
        "/modules/subscriptions/subscriptions.js",
        "/modules/subscriptions/subscriptionsmodel.js",
        "/modules/subscriptions/subscriptionsummary.js",
        "/modules/subscriptions/subscriptionsview.js",
        "/modules/tags/tags.js",
        "/modules/toggle-button/multi-toggle-button.js",
        "/modules/top-issues-chart/top-issues-chart-controller.js",
        "/modules/top-issues-chart/top-issues-chart-view.js",
        "/modules/utils/auto-resizable-textarea.js",
        "/modules/utils/avsan.js",
        "/modules/utils/cancelablepromise.js",
        "/modules/utils/click-to-edit.js",
        "/modules/utils/copy.js",
        "/modules/utils/csv.js",
        "/modules/utils/daysofweek.js",
        "/modules/utils/download-inline-svg.js",
        "/modules/utils/env.js",
        "/modules/utils/error-handler.js",
        "/modules/utils/field.js",
        "/modules/utils/filter.js",
        "/modules/utils/hashids.js",
        "/modules/utils/imageloader.js",
        "/modules/utils/lru-cache.js",
        "/modules/utils/persistence-helper.js",
        "/modules/utils/promise-pool.js",
        "/modules/utils/rectangle-transformer.js",
        "/modules/utils/shortcuts.js",
        "/modules/utils/tabs.js",
        "/modules/utils/timezoneplugin.js",
        "/modules/utils/utils.js",
        "/modules/utils/v2-url-helpers.js",
        "/modules/web-components/inst-classification-tab.js",
        "/modules/web-components/inst-editable-text-input.js",
        "/modules/web-components/inst-loading-dots.js",
        "/modules/web-components/inst-loading-wipe.js",
        "/modules/web-components/inst-short-logo.js",
        "/modules/web-components/jira-logo.js",
        "/modules/web-components/web-components.js",
        "/pages/pages.js",
        "/pages/routes.js",
        "/services/crop-images-service.js",
        "/services/files-metadata-service.js",
        "/services/monitor-crop-feedback-service.js",
        "/services/monitor-service.js",
        "/services/rum-service.js",
        "/services/users-service.js",
        "/vendor/a/a.min.js",
        "/vendor/bigscreen/bigscreen.min.js",
        "/vendor/d3-latest/d3.min.js",
        "/vendor/hashids/dist/hashids.min.js",
        "/vendor/mainloop.js/build/mainloop.min.js",
        "/vendor/qs/qs.min.js",
        "/vendor/timeago.js/timeago.min.js",
        "/vendor/tslib/tslib.min.js"
    ],
    "/bundles/control-panel-page-bundle.min.js": [
        "/modules/control-panel/control-panel-controller.js",
        "/modules/control-panel/control-panel-model.js",
        "/modules/control-panel/control-panel-view.js",
        "/modules/control-panel/filters/control-panel-bucket-filter.js",
        "/modules/control-panel/filters/control-panel-category-filter.js",
        "/modules/control-panel/filters/control-panel-date-filter.js",
        "/modules/control-panel/filters/control-panel-filters.js",
        "/modules/control-panel/filters/control-panel-line-filter.js",
        "/modules/control-panel/filters/control-panel-metric-filter.js",
        "/modules/control-panel/filters/control-panel-sort-filter.js",
        "/modules/control-panel/filters/control-panel-ymax-filter.js",
        "/pages/control-panel/control-panel-page.js"
    ],
    "/bundles/control-panel-page-metrics-page-rad-page-bundle.min.js": [
        "/modules/utils/filters.js"
    ],
    "/bundles/control-panel-page-project-home-page-bundle.min.js": [
        "/modules/control-panel/es-queries.js"
    ],
    "/bundles/correlation-page-bundle.min.js": [
        "/modules/components/copy-link-button/copy-link-button.js",
        "/modules/correlations/correlation-controller.js",
        "/modules/correlations/correlation-model.js",
        "/modules/correlations/correlation-view.js",
        "/modules/correlations/features/classification-tabs/classification-tabs.js",
        "/modules/correlations/features/correlation-results-summary/correlation-results-summary-modal.js",
        "/modules/correlations/features/correlation-results-summary/correlation-results-summary.js",
        "/modules/correlations/features/correlation-root-metric-summary/correlation-root-metric-summary.js",
        "/modules/correlations/features/distribution-chart/distribution-chart.js",
        "/modules/correlations/features/dvc-relationship-card/dvc-population-card.js",
        "/modules/correlations/features/dvc-relationship-card/dvc-relationship-card.js",
        "/modules/correlations/features/measurement-detail/measurement-detail.js",
        "/modules/correlations/features/message-card/message-card.js",
        "/modules/correlations/features/monitor-example-crops/discover-example-crops.js",
        "/modules/correlations/features/monitor-example-crops/image-monitor-example-crops.js",
        "/modules/correlations/features/monitor-example-crops/monitor-example-crops-factory.js",
        "/modules/correlations/features/monitor-example-crops/monitor-example-crops.js",
        "/modules/correlations/features/relationship-cards/monitor-expansion.js",
        "/modules/correlations/features/relationship-cards/relationship-card.js",
        "/modules/correlations/features/relationship-cards/relationship-cards.js",
        "/modules/correlations/queries/correlation-crops-service.js",
        "/modules/correlations/queries/correlation-page-addons.js",
        "/modules/correlations/shared/correlation-dvc-crop-data.js",
        "/modules/correlations/shared/correlation-results-repository.js",
        "/modules/elasticsearch/factories/external-inspections-queries.js",
        "/modules/elasticsearch/factories/external-measurements-queries.js",
        "/modules/elasticsearch/factories/monitors-queries.js",
        "/modules/subscriptions/services/crop-visuals-service.js",
        "/pages/correlations/correlation-page.js"
    ],
    "/bundles/correlation-page-correlations-page-bundle.min.js": [
        "/modules/components/date-range-picker/date-range-picker.js",
        "/modules/components/search-form/search-form.js",
        "/modules/components/selection-list/selection-list.js",
        "/modules/correlations/features/correlation-classification-list/correlation-classification-list.js",
        "/modules/correlations/features/intent-selection-card/intent-selection-card.js",
        "/modules/correlations/modals/create-correlation-modal.js",
        "/modules/correlations/queries/correlation-metrics-service.js",
        "/modules/search/events.js",
        "/modules/search/mini-search.js",
        "/modules/search/search-manager.js",
        "/modules/search/searchUtil.js",
        "/modules/search/types.js"
    ],
    "/bundles/correlation-page-grid-page-relationships-page-units-page-bundle.min.js": [
        "/modules/elasticsearch/image-configs.js",
        "/modules/mega-gad/mega-gad-helpers.js",
        "/modules/mega-gad/mega-gad-modal.js",
        "/modules/searchresults/units-to-csv.js",
        "/modules/units-export-csv/units-export-csv-modal.js"
    ],
    "/bundles/correlation-page-metrics-page-bundle.min.js": [
        "/modules/components/download-button/download-button.js",
        "/modules/components/multi-radio-slider-button/multi-radio-slider-button.js",
        "/modules/metrics/charts/control-chart-factory.js",
        "/modules/metrics/charts/control-chart-outliers-toggle.js",
        "/modules/metrics/charts/datastream-control-chart-service.js",
        "/modules/metrics/charts/physical-control-chart-service.js",
        "/modules/metrics/filters/metrics-alert-subscription-filter.js",
        "/modules/metrics/metric-automation-settings-tooltip-helper.js",
        "/modules/metrics/metric-automation-settings-view.js",
        "/modules/metrics/metric-card.js",
        "/modules/metrics/metrics-controller.js",
        "/modules/metrics/metrics-view.js",
        "/modules/modals/measurement-monitor-automation-modal.js",
        "/modules/modals/measurement-monitor-measure-more-modal.js"
    ],
    "/bundles/correlation-page-metrics-page-project-home-page-relationships-page-bundle.min.js": [
        "/modules/metrics/metrics-helpers.js"
    ],
    "/bundles/correlation-page-metrics-page-project-settings-page-bundle.min.js": [
        "/modules/components/field-status/field-status.js"
    ],
    "/bundles/correlation-page-metrics-page-relationships-page-bundle.min.js": [
        "/modules/alert-rules/metric-alert/external-metric-alert-service.js",
        "/modules/alert-rules/metric-alert/metric-alert-subscription-button.js",
        "/modules/alert-rules/metric-alert/physical-metric-alert-service.js",
        "/modules/metrics/charts/click-tooltip-contents.js",
        "/modules/metrics/charts/click-tooltip-items.js",
        "/modules/metrics/charts/control-chart-tooltip.js",
        "/modules/metrics/charts/control-chart.js",
        "/modules/metrics/metric-alert-factory.js",
        "/modules/metrics/metric-alert-helpers.js"
    ],
    "/bundles/correlation-page-metrics-page-relationships-page-units-page-bundle.min.js": [
        "/modules/measurements/measurement-types/angle-measurement-type.js",
        "/modules/measurements/measurement-types/circle-measurement-type.js",
        "/modules/measurements/measurement-types/line-measurement-type.js",
        "/modules/measurements/measurement-types/measurement-type.js",
        "/modules/measurements/measurement-types/perpendicular-measurement-type.js"
    ],
    "/bundles/correlation-page-metrics-page-units-page-bundle.min.js": [
        "/modules/components/measurement-automation/measurement-automation-photo-backdate-selector.js",
        "/modules/components/measurement-automation/measurement-automation.js",
        "/modules/components/measurement-point-reference/measurement-point-reference-model.js",
        "/modules/components/measurement-point-reference/measurement-point-reference.js",
        "/modules/components/measurement-point-selection/measurement-point-selection-model.js",
        "/modules/components/measurement-point-selection/measurement-point-selection.js",
        "/modules/measurements/bulk-measure-modal-view.js",
        "/modules/measurements/bulk-measure-modal.js"
    ],
    "/bundles/correlation-page-project-home-page-relationships-page-bundle.min.js": [
        "/modules/metrics/physical-metric-preview-repository.js",
        "/modules/metrics/physical-metric-repository.js"
    ],
    "/bundles/correlation-page-relationships-page-bundle.min.js": [
        "/modules/components/measurement-preview/drawing-overlay.js",
        "/modules/components/measurement-preview/measurement-preview.js",
        "/modules/components/measurement-preview/monitor-preview.js",
        "/modules/correlations/features/relationship-charts/relationship-chart-factories.js",
        "/modules/correlations/features/relationship-charts/relationship-chart-tooltip.js",
        "/modules/correlations/features/relationship-charts/relationship-chart.js",
        "/modules/elasticsearch/query-fragments/edi-measurements.js",
        "/modules/elasticsearch/query-fragments/physical-measurements.js",
        "/modules/relationships/charts/category-vs-category-heatmap-chart.js",
        "/modules/relationships/charts/category-vs-category-stacked-bar-chart.js",
        "/modules/relationships/charts/chart-limit-data-point-styling.js",
        "/modules/relationships/charts/chart-limit-failure-rects.js",
        "/modules/relationships/charts/chart-limit-lines.js",
        "/modules/relationships/charts/components/category-axis.js",
        "/modules/relationships/charts/components/number-axis.js",
        "/modules/relationships/charts/components/xy-points.js",
        "/modules/relationships/charts/date-vs-category-heatmap-chart.js",
        "/modules/relationships/charts/jitter-plot-data.js",
        "/modules/relationships/charts/number-vs-category-box-plot-chart.js",
        "/modules/relationships/charts/number-vs-category-jitter-plot-chart.js",
        "/modules/relationships/charts/number-vs-date-heatmap-chart.js",
        "/modules/relationships/charts/number-vs-date-scatter-plot-chart.js",
        "/modules/relationships/charts/number-vs-number-heatmap-chart.js",
        "/modules/relationships/charts/number-vs-number-scatter-plot-chart.js",
        "/modules/relationships/correlation-stats-explainer.js",
        "/modules/relationships/expanded-correlations-modal.js",
        "/modules/relationships/relationships-controller.js",
        "/modules/relationships/relationships-data-pane-chart-card.js",
        "/modules/relationships/relationships-data-pane-controller.js",
        "/modules/relationships/relationships-data-pane-export-helpers.js",
        "/modules/relationships/relationships-data-pane-tier-header.js",
        "/modules/relationships/relationships-data-pane-view.js",
        "/modules/relationships/relationships-view.js"
    ],
    "/bundles/correlation-page-relationships-page-units-page-bundle.min.js": [
        "/modules/measurements/imagemetrics.js",
        "/modules/measurements/measurements.js",
        "/modules/measurements/simplify.js",
        "/modules/unit-tools/draw-tools.js"
    ],
    "/bundles/correlations-page-bundle.min.js": [
        "/pages/correlations/correlations-page.js"
    ],
    "/bundles/dashboard-page-bundle.min.js": [
        "/modules/api/bindings/dfx/schemas/proto/subscription/SubscriptionShareType.js",
        "/modules/modals/export-pdf-modal.js",
        "/modules/modals/image-monitor-changelog-modal.js",
        "/modules/modals/subscription-edit-filters-modal.js",
        "/modules/modals/subscription-performance-modal.js",
        "/modules/modals/subscription-rename-modal.js",
        "/modules/subscriptions/cross-project-linked-monitor-group.js",
        "/modules/subscriptions/monitor-alignment/image-monitor-alignment-tool.js",
        "/modules/subscriptions/monitor-alignment/monitor-alignment-data.js",
        "/modules/subscriptions/monitor-alignment/rect-alignment-events.js",
        "/modules/subscriptions/monitor-alignment/rect-alignment-helper.js",
        "/modules/subscriptions/monitor-alignment/rect-alignment-state.js",
        "/modules/subscriptions/monitor-alignment/rect-alignment-view.js",
        "/modules/subscriptions/monitor-alignment/rect-alignment.js",
        "/modules/subscriptions/monitor-filters.js",
        "/modules/subscriptions/monitor-group-assignment-alignment-modal.js",
        "/modules/subscriptions/monitor-group-confirmation-modal.js",
        "/modules/subscriptions/monitor-group-details-modal.js",
        "/pages/dashboard/dashboard-page.js"
    ],
    "/bundles/dashboard-page-metrics-page-bundle.min.js": [
        "/modules/modals/changelog-modal.js"
    ],
    "/bundles/dashboard-page-monitor-tuning-page-bundle.min.js": [
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APISubscriptionSensitivityTradeoff.js"
    ],
    "/bundles/diagnostic-page-bundle.min.js": [
        "/pages/diagnostic/diagnostic-page.js"
    ],
    "/bundles/diagnostic-page-line-infrastructure-page-units-page-bundle.min.js": [
        "/modules/line-infrastructure/es-queries.js"
    ],
    "/bundles/diagnostic-page-units-page-bundle.min.js": [
        "/modules/components/opt-in-buttons/diagnostic-opt-in-button.js",
        "/modules/diagnostic/data/alignment-service.js",
        "/modules/diagnostic/data/discover-regions-service.js",
        "/modules/diagnostic/data/es-queries.js",
        "/modules/diagnostic/data/intent-service.js",
        "/modules/diagnostic/diagnostic-controller.js",
        "/modules/diagnostic/diagnostic-model.js",
        "/modules/diagnostic/diagnostic-view.js"
    ],
    "/bundles/discover-detail-page-bundle.min.js": [
        "/modules/discover/features/discover-detail/discover-detail-controller.js",
        "/modules/discover/features/discover-detail/discover-detail-view.js",
        "/pages/discover/discover-detail-page.js"
    ],
    "/bundles/discover-detail-page-discover-page-bundle.min.js": [
        "/modules/modals/discover-intercept-confirm-modal.js"
    ],
    "/bundles/discover-detail-page-discover-page-project-home-page-bundle.min.js": [
        "/modules/discover/queries/dates-by-review-status-service.js"
    ],
    "/bundles/discover-page-bundle.min.js": [
        "/modules/discover/features/heatmap/heatmap-toggle-intercepts-confirm-modal.js",
        "/modules/discover/features/heatmap/heatmap-toggle-intercepts-modal.js",
        "/modules/discover/features/modal/bad-photo-multi-region-selection-modal.js",
        "/modules/discover/features/modal/discover-intercept-modal.js",
        "/modules/discover/features/modal/discover-settings-modal.js",
        "/modules/modals/discover-modify-threshold-confirm-modal.js",
        "/pages/discover/discover-page.js"
    ],
    "/bundles/file-page-bundle.min.js": [
        "/modules/files/file-view.js",
        "/pages/files/file-page.js"
    ],
    "/bundles/file-page-files-page-bundle.min.js": [
        "/modules/api/bindings/dfx/schemas/proto/api/files/DFXFileStatus.js"
    ],
    "/bundles/files-page-bundle.min.js": [
        "/modules/files/files-controller.js",
        "/modules/files/files-view.js",
        "/pages/files/files-page.js"
    ],
    "/bundles/fixture-settings-page-bundle.min.js": [
        "/modules/components/project-settings/project-settings-data-list-field.js",
        "/modules/fixture-settings/boolean-fixture-setting.js",
        "/modules/fixture-settings/fixture-setting-model.js",
        "/modules/fixture-settings/fixture-setting.js",
        "/modules/fixture-settings/fixture-settings-controller.js",
        "/modules/fixture-settings/fixture-settings-model.js",
        "/modules/fixture-settings/fixture-settings-view.js",
        "/modules/fixture-settings/int-fixture-setting.js",
        "/modules/fixture-settings/json-string-fixture-setting.js",
        "/modules/fixture-settings/string-fixture-setting.js",
        "/pages/fixture-settings/fixture-settings-page.js"
    ],
    "/bundles/fixture-settings-page-project-settings-page-bundle.min.js": [
        "/modules/components/project-settings/project-settings-field.js",
        "/modules/components/project-settings/project-settings-form-section.js",
        "/modules/components/project-settings/project-settings-input-field.js",
        "/modules/components/project-settings/project-settings-select-field.js"
    ],
    "/bundles/grid-page-bundle.min.js": [
        "/modules/searchresults/grid-results-monitor-creation-flow.js",
        "/modules/searchresults/gridresults.js",
        "/pages/units/grid-page.js"
    ],
    "/bundles/grid-page-rad-page-bundle.min.js": [
        "/modules/charts/monitor-validation-chart.js",
        "/modules/subscriptions/monitor-creation-flow.js",
        "/modules/subscriptions/monitor-predictions-view.js",
        "/modules/subscriptions/monitor-predictions.js"
    ],
    "/bundles/grid-page-rad-page-units-page-bundle.min.js": [
        "/modules/utils/funnel.js"
    ],
    "/bundles/grid-page-units-page-bundle.min.js": [
        "/modules/change-intents/change-intent-modal.js",
        "/modules/change-intents/es-queries.js",
        "/modules/modals/change-config-modal.js",
        "/modules/modals/image-config-row.js",
        "/modules/searchresults/hiding.js",
        "/modules/unitbar/unitbar.js"
    ],
    "/bundles/hidden-photos-page-bundle.min.js": [
        "/modules/hidden-photos/es-queries.js",
        "/modules/hidden-photos/hidden-photos-controller.js",
        "/modules/hidden-photos/hidden-photos-grid-controller.js",
        "/modules/hidden-photos/hidden-photos-grid-view.js",
        "/modules/hidden-photos/hidden-photos-model.js",
        "/modules/hidden-photos/hidden-photos-view.js",
        "/pages/hidden-photos/hidden-photos-page.js"
    ],
    "/bundles/import-data-page-bundle.min.js": [
        "/modules/api/bindings/dfx/schemas/proto/api/externaldata/APIIngestExternalDataErrorCode.js",
        "/modules/file-upload/file-upload.js",
        "/modules/import-data/import-data-controller.js",
        "/modules/import-data/import-data-model.js",
        "/modules/import-data/import-data-view.js",
        "/modules/import-data/parse-csv.js",
        "/modules/import-data/parse.js",
        "/pages/import-data/import-data-page.js"
    ],
    "/bundles/import-tags-page-bundle.min.js": [
        "/modules/import-tags/import-tags.js",
        "/pages/import-tags/import-tags-page.js"
    ],
    "/bundles/integrations-page-bundle.min.js": [
        "/modules/integrations/integrations-controller.js",
        "/modules/integrations/integrations-model.js",
        "/modules/integrations/integrations-view.js",
        "/pages/integrations/integrations-page.js"
    ],
    "/bundles/line-infrastructure-page-bundle.min.js": [
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIAddBuildErrorCode.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIAddLineErrorCode.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIAddStationErrorCode.js",
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIAddStationFixtureErrorCode.js",
        "/modules/line-infrastructure/alignment-modal.js",
        "/modules/line-infrastructure/build-modal-view.js",
        "/modules/line-infrastructure/build-modal.js",
        "/modules/line-infrastructure/line-infrastructure-controller.js",
        "/modules/line-infrastructure/line-infrastructure-helpers.js",
        "/modules/line-infrastructure/line-infrastructure-model.js",
        "/modules/line-infrastructure/line-infrastructure-view.js",
        "/modules/line-infrastructure/line-layouts-controller.js",
        "/modules/line-infrastructure/line-layouts-view.js",
        "/modules/line-infrastructure/line-modal-view.js",
        "/modules/line-infrastructure/line-modal.js",
        "/modules/line-infrastructure/station-fixture-calibration-modal-view.js",
        "/modules/line-infrastructure/station-fixture-calibration-modal.js",
        "/modules/line-infrastructure/station-fixture-calibrations-modal-view.js",
        "/modules/line-infrastructure/station-fixture-calibrations-modal.js",
        "/modules/line-infrastructure/station-fixture-copy-calibration-modal-view.js",
        "/modules/line-infrastructure/station-fixture-copy-calibration-modal.js",
        "/modules/line-infrastructure/station-fixture-modal-view.js",
        "/modules/line-infrastructure/station-fixture-modal.js",
        "/modules/line-infrastructure/station-modal-view.js",
        "/modules/line-infrastructure/station-modal.js",
        "/modules/line-infrastructure/unassigned-station-fixtures-controller.js",
        "/modules/line-infrastructure/unassigned-station-fixtures-view.js",
        "/modules/line-infrastructure/unassigned-stations-controller.js",
        "/modules/line-infrastructure/unassigned-stations-view.js",
        "/pages/line-infrastructure/line-infrastructure-page.js"
    ],
    "/bundles/line-infrastructure-page-units-page-bundle.min.js": [
        "/modules/line-infrastructure/station-fixtures-model.js"
    ],
    "/bundles/mes-integrations-page-bundle.min.js": [
        "/modules/mes-integrations/mes-integrations-controller.js",
        "/modules/mes-integrations/mes-integrations-model.js",
        "/modules/mes-integrations/mes-integrations-view.js",
        "/modules/mes-integrations/mes-python-code-template.js",
        "/pages/mes-integrations/mes-integrations-page.js"
    ],
    "/bundles/mes-integrations-page-station-sop-page-bundle.min.js": [
        "/modules/api/sop-config-schema.js",
        "/modules/station-sop/vendor.js",
        "/vendor/monaco-editor/vs/editor/editor.main.min.js"
    ],
    "/bundles/metrics-page-bundle.min.js": [
        "/modules/metrics/filters/metrics-classification-filter.js",
        "/modules/metrics/filters/metrics-data-type-filter.js",
        "/modules/metrics/filters/metrics-filters.js",
        "/modules/metrics/filters/metrics-name-filter.js",
        "/modules/metrics/filters/metrics-retest-filter.js",
        "/modules/metrics/filters/metrics-sort-filter.js",
        "/modules/metrics/filters/metrics-station-filter.js",
        "/modules/modals/automeasure-monitor-changelog-modal.js",
        "/modules/modals/delete-physical-measurements-modal.js",
        "/pages/metrics/metrics-page.js"
    ],
    "/bundles/metrics-page-units-page-bundle.min.js": [
        "/modules/modals/delete-data-modal.js",
        "/modules/modals/delete-data-progress-modal.js",
        "/modules/modals/es-queries.js"
    ],
    "/bundles/monitor-tuning-page-bundle.min.js": [
        "/modules/monitor-tuning/es-queries.js",
        "/modules/monitor-tuning/monitor-tuning-controller.js",
        "/modules/monitor-tuning/monitor-tuning-model.js",
        "/modules/monitor-tuning/monitor-tuning-view.js",
        "/pages/monitor-tuning/monitor-tuning-page.js"
    ],
    "/bundles/ops-dashboard-page-bundle.min.js": [
        "/modules/components/change-indicator/change-indicator.js",
        "/modules/ops-dashboard/fields/ops-dashboard-time-period-field.js",
        "/modules/ops-dashboard/ops-dashboard-controller.js",
        "/modules/ops-dashboard/ops-dashboard-kpi-tile.js",
        "/modules/ops-dashboard/ops-dashboard-view.js",
        "/modules/ops-dashboard/performance-by-station-table/external-performance-by-station-row.js",
        "/modules/ops-dashboard/performance-by-station-table/image-performance-by-station-row.js",
        "/modules/ops-dashboard/performance-by-station-table/media-performance-by-station-row.js",
        "/modules/ops-dashboard/performance-by-station-table/performance-by-station-row.js",
        "/modules/ops-dashboard/performance-by-station-table/performance-by-station-table.js",
        "/modules/ops-dashboard/performance-by-station-table/performance-by-station-with-yield-row.js",
        "/modules/ops-dashboard/performance-by-station-table/video-performance-by-station-row.js",
        "/modules/ops-dashboard/tooltips/ops-dashboard-action-link.js",
        "/modules/ops-dashboard/tooltips/ops-dashboard-fpy-tooltip.js",
        "/modules/ops-dashboard/tooltips/ops-dashboard-fpy-trend-tooltip.js",
        "/modules/ops-dashboard/tooltips/ops-dashboard-fy-tooltip.js",
        "/modules/ops-dashboard/tooltips/ops-dashboard-info-tooltips.js",
        "/modules/ops-dashboard/tooltips/ops-dashboard-output-tooltip.js",
        "/modules/ops-dashboard/tooltips/ops-dashboard-retest-rate-tooltip.js",
        "/modules/ops-dashboard/tooltips/ops-dashboard-tooltip-helpers.js",
        "/modules/ops-dashboard/tooltips/ops-dashboard-uph-tooltip.js",
        "/modules/ops-dashboard/tooltips/ops-dashboard-value-tooltip-base.js",
        "/pages/ops-dashboard/ops-dashboard-page.js"
    ],
    "/bundles/ops-dashboard-page-project-home-page-bundle.min.js": [
        "/modules/ops-dashboard/charts/performance-over-time-chart-helpers.js",
        "/modules/ops-dashboard/charts/performance-over-time-chart-view.js",
        "/modules/ops-dashboard/charts/performance-over-time-chart.js",
        "/modules/ops-dashboard/queries/ops-dashboard-performance-service.js"
    ],
    "/bundles/ops-dashboard-page-project-home-page-project-settings-page-bundle.min.js": [
        "/modules/elasticsearch/query-fragments/unit-performance.js",
        "/modules/ops-dashboard/es-queries.js",
        "/modules/ops-dashboard/ops-dashboard-helpers.js",
        "/modules/ops-dashboard/ops-dashboard-kpi-bucket.js",
        "/modules/ops-dashboard/ops-dashboard-model.js"
    ],
    "/bundles/ops-dashboard-page-project-home-page-springboard-page-bundle.min.js": [
        "/modules/chart/adjustable-culling.js"
    ],
    "/bundles/poc-page-bundle.min.js": [
        "/modules/poc/poc-controller.js",
        "/modules/poc/poc-modal.js",
        "/modules/poc/poc-model.js",
        "/modules/poc/poc-view.js",
        "/pages/poc/poc-page.js"
    ],
    "/bundles/project-home-page-bundle.min.js": [
        "/modules/charts/top-issues-chart.js",
        "/modules/project-home-2/add-coverage-modal.js",
        "/modules/project-home-2/es-queries.js",
        "/modules/project-home-2/project-home-controller.js",
        "/modules/project-home-2/project-home-heatmap-entities.js",
        "/modules/project-home-2/project-home-model.js",
        "/modules/project-home-2/project-home-view.js",
        "/pages/project-home-2/project-home-page.js"
    ],
    "/bundles/project-home-page-units-page-bundle.min.js": [
        "/modules/edi/es-queries.js"
    ],
    "/bundles/project-settings-page-bundle.min.js": [
        "/modules/api/bindings/dfx/schemas/proto/api/thirdparty/APISupportedThirdPartyIntegrationProvider.js",
        "/modules/api/bindings/dfx/schemas/proto/api/thirdparty/APIThirdPartyIntegrationCategory.js",
        "/modules/components/connection-status-indicator/connection-status-indicator.js",
        "/modules/components/project-settings/project-settings-form.js",
        "/modules/components/project-settings/project-settings-spc-over-control-trigger.js",
        "/modules/components/project-settings/project-settings-spc-shift-trigger.js",
        "/modules/components/project-settings/project-settings-spc-trend-trigger.js",
        "/modules/components/project-settings/project-settings-spc-trigger.js",
        "/modules/components/project-settings/project-settings-spc-x-bar-control-limit-trigger.js",
        "/modules/components/project-settings/project-settings-toggle-field.js",
        "/modules/project-settings/features/project-settings-jira-integration-form/project-settings-jira-integration-form.js",
        "/modules/project-settings/project-settings-controller.js",
        "/modules/project-settings/project-settings-model.js",
        "/modules/project-settings/project-settings-view.js",
        "/pages/project-settings/project-settings-page.js"
    ],
    "/bundles/project-settings-page-units-page-bundle.min.js": [
        "/modules/jira/jira-helpers.js"
    ],
    "/bundles/rad-page-bundle.min.js": [
        "/modules/discover/features/discover-image-monitor-creation-flow-base.js",
        "/modules/rad/filters/rad-filters.js",
        "/modules/rad/filters/rad-heatmap-filter.js",
        "/modules/rad/filters/rad-image-config-filter.js",
        "/modules/rad/filters/rad-serial-number-filter.js",
        "/modules/rad/filters/rad-station-filter.js",
        "/modules/rad/rad-comment-entities.js",
        "/modules/rad/rad-controller.js",
        "/modules/rad/rad-heatmap-entities.js",
        "/modules/rad/rad-monitor-creation-flow.js",
        "/modules/rad/rad-view.js",
        "/pages/rad/rad-page.js"
    ],
    "/bundles/recurring-report-page-bundle.min.js": [
        "/modules/recurring-reports/recurring-report-controller.js",
        "/modules/recurring-reports/recurring-report-view.js",
        "/pages/recurring-reports/recurring-report-page.js"
    ],
    "/bundles/recurring-reports-page-bundle.min.js": [
        "/modules/recurring-reports/recurring-reports-controller.js",
        "/modules/recurring-reports/recurring-reports-view.js",
        "/pages/recurring-reports/recurring-reports-page.js"
    ],
    "/bundles/relationships-page-bundle.min.js": [
        "/pages/relationships/relationships-page.js"
    ],
    "/bundles/report-page-bundle.min.js": [
        "/modules/processflow/processflowcontroller.js",
        "/modules/processflow/processflowview.js",
        "/pages/reports/report-page.js"
    ],
    "/bundles/springboard-page-bundle.min.js": [
        "/modules/activity-chart/activity-chart-controller.js",
        "/modules/activity-chart/activity-chart-helpers.js",
        "/modules/activity-chart/activity-chart-view.js",
        "/modules/quick-stats/quick-stats-controller.js",
        "/modules/quick-stats/quick-stats-view.js",
        "/modules/springboard/es-queries.js",
        "/modules/springboard/springboard-controller.js",
        "/modules/springboard/springboard-helpers.js",
        "/modules/springboard/springboard-issues-controller.js",
        "/modules/springboard/springboard-issues-image-loader.js",
        "/modules/springboard/springboard-issues-view.js",
        "/modules/springboard/springboard-view.js",
        "/modules/toggle-button/toggle-button-controller.js",
        "/pages/springboard/springboard-page.js"
    ],
    "/bundles/station-sop-page-bundle.min.js": [
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APICreateStationSopRevisionErrorCode.js",
        "/modules/api/bindings/dfx/schemas/proto/sop/SopConfigBarcodeStep.js",
        "/modules/station-sop/default-preview-image.js",
        "/modules/station-sop/sop-generator/fields/sop-checkbox-input-field.js",
        "/modules/station-sop/sop-generator/fields/sop-field-utils.js",
        "/modules/station-sop/sop-generator/fields/sop-generator-fields-metadata.js",
        "/modules/station-sop/sop-generator/fields/sop-select-input-field.js",
        "/modules/station-sop/sop-generator/fields/sop-text-input-field.js",
        "/modules/station-sop/sop-generator/fields/tooltip.js",
        "/modules/station-sop/sop-generator/sop-generator-modal-view.js",
        "/modules/station-sop/sop-generator/sop-generator-modal.js",
        "/modules/station-sop/sop-generator/templates/sop-generator-manual-barcode-scan-template.js",
        "/modules/station-sop/station-sop-controller.js",
        "/modules/station-sop/station-sop-helpers.js",
        "/modules/station-sop/station-sop-view.js",
        "/pages/station-sop/station-sop-page.js"
    ],
    "/bundles/station-sop-page-station-sops-page-bundle.min.js": [
        "/modules/station-sops/station-sops-helpers.js"
    ],
    "/bundles/station-sops-page-bundle.min.js": [
        "/modules/station-sops/station-sops-controller.js",
        "/modules/station-sops/station-sops-view.js",
        "/pages/station-sops/station-sops-page.js"
    ],
    "/bundles/units-page-bundle.min.js": [
        "/modules/alignment-setup/alignment-setup-controller.js",
        "/modules/alignment-setup/alignment-setup-helpers.js",
        "/modules/alignment-setup/alignment-setup-image-comparison-controller.js",
        "/modules/alignment-setup/alignment-setup-image-comparison-view.js",
        "/modules/alignment-setup/alignment-setup-modal-view.js",
        "/modules/alignment-setup/alignment-setup-modal.js",
        "/modules/alignment-setup/alignment-setup-model.js",
        "/modules/alignment-setup/alignment-setup-results-controller.js",
        "/modules/alignment-setup/alignment-setup-results-view.js",
        "/modules/alignment-setup/alignment-setup-view.js",
        "/modules/alignment-setup/es-queries.js",
        "/modules/alignment-setup/fields/alignment-setup-diff-threshold-field.js",
        "/modules/alignment-setup/fields/alignment-setup-max-angle-field.js",
        "/modules/alignment-setup/fields/alignment-setup-max-offset-field.js",
        "/modules/components/crop-card/crop-labeling-details.js",
        "/modules/discover/features/discover-region-reassignment/discover-region-reassigner-view.js",
        "/modules/discover/features/discover-region-reassignment/discover-region-reassigner.js",
        "/modules/discover/features/discover-region/discover-recent-configs.js",
        "/modules/discover/features/discover-region/discover-region-grid-component.js",
        "/modules/discover/features/modal/discover-region-modal.js",
        "/modules/gallery/gallery-external-decks.js",
        "/modules/hero/hero-heatmap-rect.js",
        "/modules/hero/hero-heatmap.js",
        "/modules/hero/hero-shared.js",
        "/modules/hero/multi-region-list.js",
        "/modules/hero/region-icons.js",
        "/modules/image-config-filters/base-image-config-filters-modal.js",
        "/modules/image-config-filters/image-config-filters-modal.js",
        "/modules/jira/modals/export-unit-to-jira-modal.js",
        "/modules/measurements/measure-modal.js",
        "/modules/measurements/measurement-tuning-modal.js",
        "/modules/modals/delete-discover-regions-confirm-modal.js",
        "/modules/modals/delete-unit-modal.js",
        "/modules/modals/discover-region-reassigner-modal.js",
        "/modules/modals/downloadmodal.js",
        "/modules/modals/keyboard-shortcuts-modal-view.js",
        "/modules/modals/keyboard-shortcuts-modal.js",
        "/modules/router/keyboard-shortcuts-page.js",
        "/modules/unit-comments/unit-comment-entities.js",
        "/modules/unit-comments/unit-comments.js",
        "/modules/unit-tools/unit-tools.js",
        "/modules/unit-tray/es-queries.js",
        "/modules/unit-tray/unit-tray-helpers.js",
        "/modules/unit-tray/unit-tray.js",
        "/pages/units/units-page.js"
    ],
    "/bundles/users-page-bundle.min.js": [
        "/modules/api/bindings/dfx/schemas/proto/api/frontend/APIAddUserErrorCode.js",
        "/modules/users/modals/add-user-modal.js",
        "/modules/users/users-controller.js",
        "/pages/users/users-page.js"
    ]
},
// Instructs SystemJS to load dependent bundles concurrently with their parents
// (instead of serially after the parent is loaded) for faster page load performance.
depCache: {
    "/bundles/account-page-bundle.min.js": [
        "/bundles/account-page-bundle.min.js",
        "/bundles/account-page-users-page-bundle.min.js"
    ],
    "/bundles/activity-page-bundle.min.js": [
        "/bundles/activity-page-bundle.min.js",
        "/bundles/activity-page-report-page-springboard-page-bundle.min.js"
    ],
    "/bundles/alert-rule-page-bundle.min.js": [
        "/bundles/alert-rule-page-bundle.min.js",
        "/bundles/alert-rule-page-correlation-page-metrics-page-relationships-page-bundle.min.js",
        "/bundles/alert-rule-page-dashboard-page-recurring-report-page-users-page-bundle.min.js"
    ],
    "/bundles/alert-rules-page-bundle.min.js": [
        "/bundles/alert-rules-page-bundle.min.js"
    ],
    "/bundles/comment-threads-page-bundle.min.js": [
        "/bundles/comment-threads-page-bundle.min.js"
    ],
    "/bundles/control-panel-page-bundle.min.js": [
        "/bundles/control-panel-page-bundle.min.js",
        "/bundles/control-panel-page-metrics-page-rad-page-bundle.min.js",
        "/bundles/control-panel-page-project-home-page-bundle.min.js"
    ],
    "/bundles/correlation-page-bundle.min.js": [
        "/bundles/alert-rule-page-correlation-page-metrics-page-relationships-page-bundle.min.js",
        "/bundles/correlation-page-bundle.min.js",
        "/bundles/correlation-page-correlations-page-bundle.min.js",
        "/bundles/correlation-page-grid-page-relationships-page-units-page-bundle.min.js",
        "/bundles/correlation-page-metrics-page-bundle.min.js",
        "/bundles/correlation-page-metrics-page-project-home-page-relationships-page-bundle.min.js",
        "/bundles/correlation-page-metrics-page-project-settings-page-bundle.min.js",
        "/bundles/correlation-page-metrics-page-relationships-page-bundle.min.js",
        "/bundles/correlation-page-metrics-page-relationships-page-units-page-bundle.min.js",
        "/bundles/correlation-page-metrics-page-units-page-bundle.min.js",
        "/bundles/correlation-page-project-home-page-relationships-page-bundle.min.js",
        "/bundles/correlation-page-relationships-page-bundle.min.js",
        "/bundles/correlation-page-relationships-page-units-page-bundle.min.js"
    ],
    "/bundles/correlations-page-bundle.min.js": [
        "/bundles/correlation-page-correlations-page-bundle.min.js",
        "/bundles/correlations-page-bundle.min.js"
    ],
    "/bundles/dashboard-page-bundle.min.js": [
        "/bundles/alert-rule-page-dashboard-page-recurring-report-page-users-page-bundle.min.js",
        "/bundles/dashboard-page-bundle.min.js",
        "/bundles/dashboard-page-metrics-page-bundle.min.js",
        "/bundles/dashboard-page-monitor-tuning-page-bundle.min.js"
    ],
    "/bundles/diagnostic-page-bundle.min.js": [
        "/bundles/diagnostic-page-bundle.min.js",
        "/bundles/diagnostic-page-line-infrastructure-page-units-page-bundle.min.js",
        "/bundles/diagnostic-page-units-page-bundle.min.js"
    ],
    "/bundles/discover-detail-page-bundle.min.js": [
        "/bundles/discover-detail-page-bundle.min.js",
        "/bundles/discover-detail-page-discover-page-bundle.min.js",
        "/bundles/discover-detail-page-discover-page-project-home-page-bundle.min.js"
    ],
    "/bundles/discover-page-bundle.min.js": [
        "/bundles/discover-detail-page-discover-page-bundle.min.js",
        "/bundles/discover-detail-page-discover-page-project-home-page-bundle.min.js",
        "/bundles/discover-page-bundle.min.js"
    ],
    "/bundles/file-page-bundle.min.js": [
        "/bundles/file-page-bundle.min.js",
        "/bundles/file-page-files-page-bundle.min.js"
    ],
    "/bundles/files-page-bundle.min.js": [
        "/bundles/file-page-files-page-bundle.min.js",
        "/bundles/files-page-bundle.min.js"
    ],
    "/bundles/fixture-settings-page-bundle.min.js": [
        "/bundles/fixture-settings-page-bundle.min.js",
        "/bundles/fixture-settings-page-project-settings-page-bundle.min.js"
    ],
    "/bundles/grid-page-bundle.min.js": [
        "/bundles/correlation-page-grid-page-relationships-page-units-page-bundle.min.js",
        "/bundles/grid-page-bundle.min.js",
        "/bundles/grid-page-rad-page-bundle.min.js",
        "/bundles/grid-page-rad-page-units-page-bundle.min.js",
        "/bundles/grid-page-units-page-bundle.min.js"
    ],
    "/bundles/hidden-photos-page-bundle.min.js": [
        "/bundles/hidden-photos-page-bundle.min.js"
    ],
    "/bundles/import-data-page-bundle.min.js": [
        "/bundles/import-data-page-bundle.min.js"
    ],
    "/bundles/import-tags-page-bundle.min.js": [
        "/bundles/import-tags-page-bundle.min.js"
    ],
    "/bundles/integrations-page-bundle.min.js": [
        "/bundles/integrations-page-bundle.min.js"
    ],
    "/bundles/line-infrastructure-page-bundle.min.js": [
        "/bundles/diagnostic-page-line-infrastructure-page-units-page-bundle.min.js",
        "/bundles/line-infrastructure-page-bundle.min.js",
        "/bundles/line-infrastructure-page-units-page-bundle.min.js"
    ],
    "/bundles/login-bundle.min.js": [
        "/bundles/common-bundle.min.js"
    ],
    "/bundles/mes-integrations-page-bundle.min.js": [
        "/bundles/mes-integrations-page-bundle.min.js",
        "/bundles/mes-integrations-page-station-sop-page-bundle.min.js"
    ],
    "/bundles/metrics-page-bundle.min.js": [
        "/bundles/alert-rule-page-correlation-page-metrics-page-relationships-page-bundle.min.js",
        "/bundles/control-panel-page-metrics-page-rad-page-bundle.min.js",
        "/bundles/correlation-page-metrics-page-bundle.min.js",
        "/bundles/correlation-page-metrics-page-project-home-page-relationships-page-bundle.min.js",
        "/bundles/correlation-page-metrics-page-project-settings-page-bundle.min.js",
        "/bundles/correlation-page-metrics-page-relationships-page-bundle.min.js",
        "/bundles/correlation-page-metrics-page-relationships-page-units-page-bundle.min.js",
        "/bundles/correlation-page-metrics-page-units-page-bundle.min.js",
        "/bundles/dashboard-page-metrics-page-bundle.min.js",
        "/bundles/metrics-page-bundle.min.js",
        "/bundles/metrics-page-units-page-bundle.min.js"
    ],
    "/bundles/monitor-tuning-page-bundle.min.js": [
        "/bundles/dashboard-page-monitor-tuning-page-bundle.min.js",
        "/bundles/monitor-tuning-page-bundle.min.js"
    ],
    "/bundles/ops-dashboard-page-bundle.min.js": [
        "/bundles/ops-dashboard-page-bundle.min.js",
        "/bundles/ops-dashboard-page-project-home-page-bundle.min.js",
        "/bundles/ops-dashboard-page-project-home-page-project-settings-page-bundle.min.js",
        "/bundles/ops-dashboard-page-project-home-page-springboard-page-bundle.min.js"
    ],
    "/bundles/poc-page-bundle.min.js": [
        "/bundles/poc-page-bundle.min.js"
    ],
    "/bundles/project-home-page-bundle.min.js": [
        "/bundles/control-panel-page-project-home-page-bundle.min.js",
        "/bundles/correlation-page-metrics-page-project-home-page-relationships-page-bundle.min.js",
        "/bundles/correlation-page-project-home-page-relationships-page-bundle.min.js",
        "/bundles/discover-detail-page-discover-page-project-home-page-bundle.min.js",
        "/bundles/ops-dashboard-page-project-home-page-bundle.min.js",
        "/bundles/ops-dashboard-page-project-home-page-project-settings-page-bundle.min.js",
        "/bundles/ops-dashboard-page-project-home-page-springboard-page-bundle.min.js",
        "/bundles/project-home-page-bundle.min.js",
        "/bundles/project-home-page-units-page-bundle.min.js"
    ],
    "/bundles/project-settings-page-bundle.min.js": [
        "/bundles/correlation-page-metrics-page-project-settings-page-bundle.min.js",
        "/bundles/fixture-settings-page-project-settings-page-bundle.min.js",
        "/bundles/ops-dashboard-page-project-home-page-project-settings-page-bundle.min.js",
        "/bundles/project-settings-page-bundle.min.js",
        "/bundles/project-settings-page-units-page-bundle.min.js"
    ],
    "/bundles/rad-page-bundle.min.js": [
        "/bundles/control-panel-page-metrics-page-rad-page-bundle.min.js",
        "/bundles/grid-page-rad-page-bundle.min.js",
        "/bundles/grid-page-rad-page-units-page-bundle.min.js",
        "/bundles/rad-page-bundle.min.js"
    ],
    "/bundles/recurring-report-page-bundle.min.js": [
        "/bundles/alert-rule-page-dashboard-page-recurring-report-page-users-page-bundle.min.js",
        "/bundles/recurring-report-page-bundle.min.js"
    ],
    "/bundles/recurring-reports-page-bundle.min.js": [
        "/bundles/recurring-reports-page-bundle.min.js"
    ],
    "/bundles/relationships-page-bundle.min.js": [
        "/bundles/alert-rule-page-correlation-page-metrics-page-relationships-page-bundle.min.js",
        "/bundles/correlation-page-grid-page-relationships-page-units-page-bundle.min.js",
        "/bundles/correlation-page-metrics-page-project-home-page-relationships-page-bundle.min.js",
        "/bundles/correlation-page-metrics-page-relationships-page-bundle.min.js",
        "/bundles/correlation-page-metrics-page-relationships-page-units-page-bundle.min.js",
        "/bundles/correlation-page-project-home-page-relationships-page-bundle.min.js",
        "/bundles/correlation-page-relationships-page-bundle.min.js",
        "/bundles/correlation-page-relationships-page-units-page-bundle.min.js",
        "/bundles/relationships-page-bundle.min.js"
    ],
    "/bundles/report-page-bundle.min.js": [
        "/bundles/activity-page-report-page-springboard-page-bundle.min.js",
        "/bundles/report-page-bundle.min.js"
    ],
    "/bundles/springboard-page-bundle.min.js": [
        "/bundles/activity-page-report-page-springboard-page-bundle.min.js",
        "/bundles/ops-dashboard-page-project-home-page-springboard-page-bundle.min.js",
        "/bundles/springboard-page-bundle.min.js"
    ],
    "/bundles/station-sop-page-bundle.min.js": [
        "/bundles/mes-integrations-page-station-sop-page-bundle.min.js",
        "/bundles/station-sop-page-bundle.min.js",
        "/bundles/station-sop-page-station-sops-page-bundle.min.js"
    ],
    "/bundles/station-sops-page-bundle.min.js": [
        "/bundles/station-sop-page-station-sops-page-bundle.min.js",
        "/bundles/station-sops-page-bundle.min.js"
    ],
    "/bundles/units-page-bundle.min.js": [
        "/bundles/correlation-page-grid-page-relationships-page-units-page-bundle.min.js",
        "/bundles/correlation-page-metrics-page-relationships-page-units-page-bundle.min.js",
        "/bundles/correlation-page-metrics-page-units-page-bundle.min.js",
        "/bundles/correlation-page-relationships-page-units-page-bundle.min.js",
        "/bundles/diagnostic-page-line-infrastructure-page-units-page-bundle.min.js",
        "/bundles/diagnostic-page-units-page-bundle.min.js",
        "/bundles/grid-page-rad-page-units-page-bundle.min.js",
        "/bundles/grid-page-units-page-bundle.min.js",
        "/bundles/line-infrastructure-page-units-page-bundle.min.js",
        "/bundles/metrics-page-units-page-bundle.min.js",
        "/bundles/project-home-page-units-page-bundle.min.js",
        "/bundles/project-settings-page-units-page-bundle.min.js",
        "/bundles/units-page-bundle.min.js"
    ],
    "/bundles/users-page-bundle.min.js": [
        "/bundles/account-page-users-page-bundle.min.js",
        "/bundles/alert-rule-page-dashboard-page-recurring-report-page-users-page-bundle.min.js",
        "/bundles/users-page-bundle.min.js"
    ]
},
});
